import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";



function AbonosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_NOTAS_CARGO = process.env.REACT_APP_URL_NOTAS_CARGO;
  const URL_SALDO_INICIAL = process.env.REACT_APP_URL_SALDO_INICIAL;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedClienteNombre, setSelectedClienteNombre] = useState("");
  const [selectedClienteTelefono, setSelectedClienteTelefono] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [alertasEdoCtaCliente, setAlertasEdoCtaCliente] = useState("No");

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [formaPago, setFormaPago] = useState("Transfer");

  const [observaciones, setObservaciones] = useState("NA");

  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [concepto, setConcepto] = useState("Abono");
  const [total, setTotal] = useState(0);
  const [importeAplicar, setImporteAplicar] = useState(0);
  const [saldoAplicar, setSaldoAplicar] = useState(0);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());
  const [moneda, setMoneda] = useState("");

  const [inputFields, setInputFields] = useState([]);
  const [inputFieldsNC, setInputFieldsNC] = useState([]);
  const [inputFieldsSI, setInputFieldsSI] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
    axios
    .get(`${URL_CLIENTES}GeneralActivos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

  if(selectedCliente != ""){
        
    axios
      .get(`${URL_SURTIDOS}Cliente/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargos = response.data;
        let arrayTabla = allCargos
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              total_general: a.total_general,
              saldo: a.saldo,
              nota: a.idSurtido,
              importe: a.saldo,
              importeOriginal: a.saldo,
              clientes: a.clientes[0]._id,
              colaboradores: a.clientes[0].vendedor[0]._id,
              observaciones: "NA",
              movimiento: "Nota",
              select:false,
              bonificacion:0,
              abonos: a.total_general - a.saldo,
              factura: a.noFactura,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setInputFields(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_NOTAS_CARGO}Cliente/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargosNC = response.data;
        let arrayTablaNC = allCargosNC
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              total_general: a.importe,
              saldo: a.saldo,
              nota: a.idNotaCargo,
              importe: a.saldo,
              importeOriginal: a.saldo,
              clientes: a.clientes[0]._id,
              colaboradores: a.clientes[0].vendedor[0]._id,
              observaciones: "NA",
              movimiento: "Nota de Cargo",
              select:false,
              bonificacion:0,
              abonos: a.importe - a.saldo,
              factura:"NA"
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinalNC = Object.values(arrayTablaNC);
        setInputFieldsNC(dataFinalNC);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_SALDO_INICIAL}Cliente/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCargosSI = response.data;
        let arrayTablaSI = allCargosSI
          .map((a) => {
            return {
              id: a._id,
              fecha: a.fecha,
              total_general: a.importe,
              saldo: a.saldo,
              nota: a.idSaldoInicial,
              importe: a.saldo,
              importeOriginal: a.saldo,
              clientes: a.clientes[0]._id,
              colaboradores: a.clientes[0].vendedor[0]._id,
              observaciones: "NA",
              movimiento: "Salldo Inicial",
              select:false,
              bonificacion:0,
              abonos: a.importe - a.saldo,
              factura:"NA"
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinalSI = Object.values(arrayTablaSI);
        setInputFieldsSI(dataFinalSI);
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }, [selectedCliente]);

  const handleChangeInputImporte = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo) {
          i.importe = value;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo o no puede quedar vacio",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputBonificacion = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo) {
          i.bonificacion = value;
          i.importe = i.importeOriginal - value
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo o no puede quedar vacio",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputBonificacionNC = (value, name, id) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo) {
          i.bonificacion = value;
          i.importe = i.importeOriginal - value
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo o no puede quedar vacio",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };

  const handleChangeInputImporteNC = (value, name, id) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo) {
          i.importe = value;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo o no puede quedar vacio",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };

  
  const handleChangeInputBonificacionSI = (value, name, id) => {
    const newInputFieldsSI = inputFieldsSI.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo) {
          i.bonificacion = value;
          i.importe = i.importeOriginal - value
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo o no puede quedar vacio",
          });
        }
      }
      return i;
    });
    setInputFieldsSI(newInputFieldsSI);
    ActualizaTotales();
  };

  const handleChangeInputImporteSI = (value, name, id) => {
    const newInputFieldsSI = inputFieldsSI.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo) {
          i.importe = value;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo o no puede quedar vacio",
          });
        }
      }
      return i;
    });
    setInputFieldsSI(newInputFieldsSI);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let activos = inputFields.filter((e) => e.select == true);
    let TEfe = activos.map((c) => parseFloat(c.importe));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    let activosNC = inputFieldsNC.filter((e) => e.select == true);
    let TEfeNC = activosNC.map((c) => parseFloat(c.importe));
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);

    let activosSI = inputFieldsSI.filter((e) => e.select == true);
    let TEfeSI = activosSI.map((c) => parseFloat(c.importe));
    let TESI = TEfeSI.reduce((t, total, index) => t + total, 0);

    let TF = parseFloat(TE).toFixed(2)
    let TFNC = parseFloat(TENC).toFixed(2)
    let TFSI = parseFloat(TESI).toFixed(2)

    let sum = (parseFloat(TF) + parseFloat(TFNC) + parseFloat(TFSI)).toFixed(2)

    setTotal(sum);

    setSaldoAplicar((importeAplicar - sum).toFixed(2));
  }

  function savePago() {
    setValidaBoton(false);

    let red = parseFloat(importeAplicar).toFixed(2)
    if (
      value != null &&
      concepto != "" &&
      formaPago != "" &&
      selectedBanco != ""
    ) {
      if (
        // saldoAplicar == 0 && 
        red == total) {
        Swal.fire({
          title: "Estas seguro?",
          text: "Se registrará el abono",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Enviar!",
        }).then((result) => {
          if (result.isConfirmed) {
            toggleProgreso();

            let activos = inputFields.filter((e) => e.select == true);
            let activosNC = inputFieldsNC.filter((e) => e.select == true);
            let activosSI = inputFieldsSI.filter((e) => e.select == true);

            let totalMails = (activos.length + activosNC.length + activosSI.length)*2
            inputFields.map((a) => {
              if (a.select == true) {
                if( a.importe > 0){
                axios
                  .post(
                    URL_ABONOS,
                    {
                      fecha,
                      importe: parseFloat(a.importe),
                      clientes: selectedCliente,
                      colaboradores: a.colaboradores,
                      surtidos: a.id,
                      formaPago,
                      concepto,
                      bancos: selectedBanco,
                      comisionPagada: "No",
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      editado:"No",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_SURTIDOS}/${a.id}`,
                      {
                        saldo: a.saldo - a.importe - a.bonificacion,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: a.importe,
                        tipo:"Ingreso",
                        bancos: selectedBanco,
                        abonos:data.data._id,
                        moneda,
                        tipoCambio:1
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )

                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                      PDFOC();
                      }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
                } else {
                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                        PDFOC();
                        }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  }
              // Termina el if importe >0

                 if (a.bonificacion > 0){
                  
                axios
                  .post(
                    URL_ABONOS,
                    {
                      fecha,
                      importe: parseFloat(a.bonificacion),
                      clientes: selectedCliente,
                      colaboradores: a.colaboradores,
                      surtidos: a.id,
                      formaPago,
                      concepto:"Bonificacion",
                      bancos: "6255c1bb98f8a71d7414a110",
                      comisionPagada: "No",
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      editado:"No",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_SURTIDOS}/${a.id}`,
                      {
                        saldo: a.saldo - a.importe - a.bonificacion,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: a.bonificacion,
                        tipo:"Ingreso",
                        bancos: "6255c1bb98f8a71d7414a110",
                        abonos:data.data._id,
                        moneda,
                        tipoCambio:1
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )

                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                      PDFOC();
                      }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
                } else {
                  totalMails = totalMails - 1;
                  if (totalMails == 0) {
                    if(alertasEdoCtaCliente == "Si"){
                      PDFOC();
                      }
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 3000);
                  }
                }
              } 
              // else {
              //   totalMails = totalMails - 1;
              //   if (totalMails == 0) {
              //     if(alertasEdoCtaCliente == "Si"){
              //       PDFOC();
              //       }
              //     Swal.fire("Good job!", "Creado con exito", "success");
              //     setTimeout(() => {
              //       window.location.reload();
              //     }, 3000);
              //   }
              // }
            });

            // Notas Cargo
            inputFieldsNC.map((a) => {
              if (a.select == true ) {
                if(a.importe > 0){
                axios
                  .post(
                    URL_ABONOS,
                    {
                      fecha,
                      importe: a.importe,
                      clientes: selectedCliente,
                      colaboradores: a.colaboradores,
                      notasCargo: a.id,
                      formaPago,
                      concepto,
                      bancos: selectedBanco,
                      comisionPagada: "No",
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      editado:"No"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_NOTAS_CARGO}AplicarAbono/${a.id}`,
                      {
                        saldo: a.saldo - a.importe - a.bonificacion,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: a.importe,
                        tipo:"Ingreso",
                        bancos: selectedBanco,
                        abonos:data.data._id,
                        moneda,
                        tipoCambio:1
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )

                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                        PDFOC();
                        }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
                } else {
                  totalMails = totalMails - 1;
                  if (totalMails == 0) {
                    if(alertasEdoCtaCliente == "Si"){
                      PDFOC();
                      }
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 3000);
                  }
                }
               if ( a.bonificacion > 0) {
                axios
                  .post(
                    URL_ABONOS,
                    {
                      fecha,
                      importe: a.bonificacion,
                      clientes: selectedCliente,
                      colaboradores: a.colaboradores,
                      notasCargo: a.id,
                      formaPago,
                      concepto:"Bonificacion",
                      bancos: "6255c1bb98f8a71d7414a110",
                      comisionPagada: "No",
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      editado:"No"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_NOTAS_CARGO}AplicarAbono/${a.id}`,
                      {
                        saldo: a.saldo - a.importe - a.bonificacion,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: a.bonificacion,
                        tipo:"Ingreso",
                        bancos: "6255c1bb98f8a71d7414a110",
                        abonos:data.data._id,
                        moneda,
                        tipoCambio:1
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )

                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                        PDFOC();
                        }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              } else {
                totalMails = totalMails - 1;
                if (totalMails == 0) {
                  if(alertasEdoCtaCliente == "Si"){
                    PDFOC();
                    }
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 3000);
                }
              }
            }  
            // else {
            //     totalMails = totalMails - 1;
            //     if (totalMails == 0) {
            //       if(alertasEdoCtaCliente == "Si"){
            //         PDFOC();
            //         }
            //       Swal.fire("Good job!", "Creado con exito", "success");
            //       setTimeout(() => {
            //         window.location.reload();
            //       }, 3000);
            //     }
            //   }
            });

            // Saldo Inicial
            inputFieldsSI.map((a) => {
              if (a.select == true ) {
                if(a.importe > 0){
                axios
                  .post(
                    URL_ABONOS,
                    {
                      fecha,
                      importe: a.importe,
                      clientes: selectedCliente,
                      colaboradores: a.colaboradores,
                      saldoInicial: a.id,
                      formaPago,
                      concepto,
                      bancos: selectedBanco,
                      comisionPagada: "No",
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      editado:"No"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_SALDO_INICIAL}AplicarAbono/${a.id}`,
                      {
                        saldo: a.saldo - a.importe - a.bonificacion,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: a.importe,
                        tipo:"Ingreso",
                        bancos: selectedBanco,
                        abonos:data.data._id,
                        moneda,
                        tipoCambio:1
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )

                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                        PDFOC();
                        }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
                } else {
                  totalMails = totalMails - 1;
                  if (totalMails == 0) {
                    if(alertasEdoCtaCliente == "Si"){
                      PDFOC();
                      }
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 3000);
                  }
                }
               if ( a.bonificacion > 0) {
                axios
                  .post(
                    URL_ABONOS,
                    {
                      fecha,
                      importe: a.bonificacion,
                      clientes: selectedCliente,
                      colaboradores: a.colaboradores,
                      saldoInicial: a.id,
                      formaPago,
                      concepto:"Bonificacion",
                      bancos: "6255c1bb98f8a71d7414a110",
                      comisionPagada: "No",
                      observaciones: a.observaciones,
                      codigoAgrupado,
                      editado:"No"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    axios.patch(
                      `${URL_SALDO_INICIAL}AplicarAbono/${a.id}`,
                      {
                        saldo: a.saldo - a.importe - a.bonificacion,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

                    axios
                    .post(
                      `${URL_MOVIMIENTOS_BANCOS}`,
                      {
                        fecha,
                        importe: a.bonificacion,
                        tipo:"Ingreso",
                        bancos: "6255c1bb98f8a71d7414a110",
                        abonos:data.data._id,
                        moneda,
                        tipoCambio:1
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )

                    totalMails = totalMails - 1;
                    if (totalMails == 0) {
                      if(alertasEdoCtaCliente == "Si"){
                        PDFOC();
                        }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              } else {
                totalMails = totalMails - 1;
                if (totalMails == 0) {
                  if(alertasEdoCtaCliente == "Si"){
                    PDFOC();
                    }
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 3000);
                }
              }
            }  
            // else {
            //     totalMails = totalMails - 1;
            //     if (totalMails == 0) {
            //       if(alertasEdoCtaCliente == "Si"){
            //         PDFOC();
            //         }
            //       Swal.fire("Good job!", "Creado con exito", "success");
            //       setTimeout(() => {
            //         window.location.reload();
            //       }, 3000);
            //     }
            //   }
            });
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Todavia te queda Saldo por aplicar",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes completar todo el formulario",
      });
    }
  }

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value.trim() === "" ? "NA" : event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputNC = (id, event) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value.trim() === "" ? "NA" : event.target.value;
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
  };

  const handleChangeInputSI = (id, event) => {
    const newInputFieldsSI = inputFieldsSI.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value.trim() === "" ? "NA" : event.target.value;
      }
      return i;
    });
    setInputFieldsSI(newInputFieldsSI);
  };

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function IA(e) {
    setImporteAplicar(e);
    let activos = inputFields.filter((e) => e.select == true);
    let TEfe = activos.map((c) => parseFloat(c.importe));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    let activosNC = inputFieldsNC.filter((e) => e.select == true);
    let TEfeNC = activosNC.map((c) => parseFloat(c.importe));
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);

    let activosSI = inputFieldsSI.filter((e) => e.select == true);
    let TEfeSI = activosSI.map((c) => parseFloat(c.importe));
    let TESI = TEfeSI.reduce((t, total, index) => t + total, 0);

    let TF = parseFloat(TE).toFixed(2)
    let TFNC = parseFloat(TENC).toFixed(2)
    let TFSI = parseFloat(TESI).toFixed(2)

    let sum = (parseFloat(TF) + parseFloat(TFNC) + parseFloat(TFSI)).toFixed(2)

    setTotal(sum);

    setSaldoAplicar((e - sum).toFixed(2));
  }

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

 async function PDFOC() {
    await axios
    .get(`${URL_ESTADO_CUENTA}Agrupado/${selectedCliente}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let movimientos = response.data;

    let saldoParcial = 0;
    let totalCargos = 0;
    let totalAbonos = 0;

    const data = movimientos.map((a) => {
        totalCargos = totalCargos + a.cargo;
        totalAbonos = totalAbonos + a.abono;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        return [
          a.fecha,
          a.movimiento,
          a.numero,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Cliente ${selectedClienteNombre}`, 15, 37);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#023875"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#023875"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
        ],
        [
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
        ],
        [
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    var attW = doc.output("arraybuffer");
    let params = new URLSearchParams({
      number: selectedClienteTelefono,
      message:`Hola ${selectedClienteNombre}, Gracias por tu pago de ${new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}. Aquí te enviamos tu estado de cuenta actualizado`,
      fileName:`EstadoCuenta.pdf`,
      mimetype: "application/pdf",
    })
    axios
    .post(
      `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
      attW,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
          "Content-Type": "application/octet-stream",
        },
      }
    )

        //
      })
      .catch((err) => {
        console.log(err);
      });

  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.abonosCreate ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      if (selectedCliente) {
                        setValue(selectedCliente);
                        setSelectedCliente(selectedCliente._id);
                        setSelectedClienteNombre(selectedCliente.nombre_comercial);
                        setSelectedClienteTelefono(selectedCliente.telefono);
                        setAlertasEdoCtaCliente(selectedCliente.alertasEdoCta);
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => {
                      setConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Concepto</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label className="mr-sm-2">Forma de Pago</Label>
                  <Input
                    type="select"
                    value={formaPago}
                    onChange={(e) => {
                      setFormaPago(e.target.value);
                    }}
                  >
                    <option value="">Selecciona una Forma de Pago</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transfer">Transfer</option>
                    <option value="TDC">TDC</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}
                    </Badge>
                  </h4>
                </Col>
              </Row>
              {/* <Row>
              <Col md={5}>
                  <Label className="mr-sm-2">Observaciones</Label>
                  <Input
                    type="text"
                    value={observaciones}
                    onChange={(e) => {
                      setObservaciones(e.target.value);
                    }}
                  />
                </Col>

                </Row> */}
              <br />
              <Row>
                <Col md={2}>
                  <Label>Importe Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={importeAplicar}
                    className={`form-control`}
                    onValueChange={(value, name) => IA(value)}
                  />
                </Col>
                <Col md={2}>
                  <Label>Saldo Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={saldoAplicar}
                    className={`form-control`}
                    disabled
                  />
                </Col>
              </Row>
              <br />
              <Row>
                {/* Tabla Cargos */}
                <br />
                <br />
                <Table striped borderless>
                  <thead>
                    <tr>
                    <th></th>
                      <th>Fecha</th>
                      <th>Movimiento</th>
                      <th>Nota</th>
                      <th>Factura</th>
                      <th>Total</th>
                      <th>Abonos</th>
                      <th>Bonificacion</th>
                      <th>Saldo</th>
                      <th>Importe</th>
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((a) => (
                      // <div key={a.id}>
                      <tr>
                         <th>
                        <Input
                              type="checkbox"
                              onChange={e => {
                                let checked = e.target.checked;
                                setInputFields(
                                  inputFields.map(data => {
                                    if(a.id == data.id){
                                    data.select = checked;
                                    } 
                                    return data;
                                  })
                                );
                                ActualizaTotales()
                              }}
                              checked={a.select}
                            />
                        </th>
                        <td>{a.fecha}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>{a.factura}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos)}
                        </td>
                        <td>{a.select ?(
                        <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="bonificacion"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.bonificacion}
                            className={`form-control`}
                            required
                            onValueChange={(value, name) =>
                              handleChangeInputBonificacion(value, name, a.id)
                            }
                          />
                          ):(
                            <CurrencyInput
                                intlConfig={{ locale: "en-US", currency: "USD" }}
                                prefix="$"
                                name="bonificacion"
                                defaultValue={0}
                                decimalsLimit={2}
                                value={a.bonificacion}
                                className={`form-control`}
                                disabled
                              />
                              )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo)}
                        </td>
                        <td>{a.select ?(
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="importe"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.importe}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputImporte(value, name, a.id)
                            }
                          />
                          ):(
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              disabled
                            />
                            )}
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            required
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                      </tr>
                      // </div>
                    ))}

                    {inputFieldsNC.map((a) => (
                      // <div key={a.id}>
                      <tr>
                      <th>
                     <Input
                           type="checkbox"
                           onChange={e => {
                             let checked = e.target.checked;
                             setInputFieldsNC(
                               inputFieldsNC.map(data => {
                                 if(a.id == data.id){
                                 data.select = checked;
                                 } 
                                 return data;
                               })
                             );
                             ActualizaTotales()
                           }}
                           checked={a.select}
                         />
                     </th>
                        <td>{a.fecha}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>{a.factura}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos)}
                        </td>
                        <td>
                          {a.select?(
                        <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="bonificacion"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.bonificacion}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputBonificacionNC(value, name, a.id)
                            }
                          />):(
                            <CurrencyInput
                                intlConfig={{ locale: "en-US", currency: "USD" }}
                                prefix="$"
                                name="bonificacion"
                                defaultValue={0}
                                decimalsLimit={2}
                                value={a.bonificacion}
                                className={`form-control`}
                                disabled
                              />)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo)}
                        </td>
                        <td>
                          {a.select?(
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="importe"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.importe}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputImporteNC(value, name, a.id)
                            }
                          />):(
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              disabled
                            />)}
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            required
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputNC(a.id, e);
                            }}
                          />
                        </td>
                      </tr>
                      // </div>
                    ))}

                    {inputFieldsSI.map((a) => (
                      // <div key={a.id}>
                      <tr>
                      <th>
                     <Input
                           type="checkbox"
                           onChange={e => {
                             let checked = e.target.checked;
                             setInputFieldsSI(
                               inputFieldsSI.map(data => {
                                 if(a.id == data.id){
                                 data.select = checked;
                                 } 
                                 return data;
                               })
                             );
                             ActualizaTotales()
                           }}
                           checked={a.select}
                         />
                     </th>
                        <td>{a.fecha}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>{a.factura}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              a.total_general
                            )}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos)}
                        </td>
                        <td>
                          {a.select?(
                        <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="bonificacion"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.bonificacion}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputBonificacionSI(value, name, a.id)
                            }
                          />):(
                            <CurrencyInput
                                intlConfig={{ locale: "en-US", currency: "USD" }}
                                prefix="$"
                                name="bonificacion"
                                defaultValue={0}
                                decimalsLimit={2}
                                value={a.bonificacion}
                                className={`form-control`}
                                disabled
                              />)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo)}
                        </td>
                        <td>
                          {a.select?(
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="importe"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.importe}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputImporteSI(value, name, a.id)
                            }
                          />):(
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              disabled
                            />)}
                        </td>
                        <td>
                          <Input
                            bsSize="sm"
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputSI(a.id, e);
                            }}
                          />
                        </td>
                      </tr>
                      // </div>
                    ))}

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        Total
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                  <br />
                </Table>

                {/* Termina tabla cargos */}
              </Row>
            </FormGroup>
            <br />
            <Row>
              <Button className="btn btn-success" onClick={savePago}>
                {" "}
                Registrar
              </Button>

              <Button
                href="/ListadoAbonos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      
    </>
  );
}

export default AbonosCreate;
